/* ============================================================
   PRISMAX — PDP module interactions
   (before/after slider, generic selectors)
   Loads alongside prismax-pages.js
   ============================================================ */
(function () {
  // ---- generic selector groups (finish / grade / swatch) ----
  // <div class="[group]" data-select="#outputId"> with children carrying
  // .on + data-val. Clicking sets active + writes label to output.
  document.querySelectorAll('[data-select]').forEach(function (group) {
    var out = document.querySelector(group.getAttribute('data-select'));
    var opts = group.querySelectorAll('[data-val]');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('on'); });
        opt.classList.add('on');
        if (out) out.textContent = opt.getAttribute('data-val');
      });
    });
  });

  // ---- variant price switcher ----
  // .pill-select[data-pricevar] with .pill-opt[data-val][data-price][data-was]
  document.querySelectorAll('[data-pricevar]').forEach(function (group) {
    var ov = group.getAttribute('data-ov') ? document.querySelector(group.getAttribute('data-ov')) : null;
    function rs(n) { return 'Rs. ' + Number(n).toLocaleString('en-IN'); }
    group.querySelectorAll('.pill-opt').forEach(function (pill) {
      pill.addEventListener('click', function () {
        group.querySelectorAll('.pill-opt').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        var price = +pill.getAttribute('data-price'); var was = +pill.getAttribute('data-was') || 0;
        if (ov) ov.textContent = pill.getAttribute('data-val');
        var nowEl = document.querySelector('.buy .bprice .now'); if (nowEl) nowEl.textContent = rs(price);
        var wasEl = document.querySelector('.buy .bprice .was'); if (wasEl) wasEl.textContent = was ? rs(was) : '';
        var offEl = document.querySelector('.buy .bprice .off'); if (offEl) offEl.textContent = was ? ('SAVE ' + Math.round((1 - price / was) * 100) + '%') : '';
        document.querySelectorAll('[data-addbtn]').forEach(function (b) { b.textContent = 'Add to cart · ' + rs(price); });
        var sp = document.querySelector('.sticky-buy .sb-price'); if (sp) sp.innerHTML = (was ? '<span class="was">' + rs(was) + '</span>' : '') + rs(price);
      });
    });
  });

  // ---- before / after slider ----
  document.querySelectorAll('[data-ba]').forEach(function (ba) {
    var after = ba.querySelector('.ba-after');
    var divider = ba.querySelector('.ba-divider');
    var handle = ba.querySelector('.ba-handle');
    var dragging = false;
    function setPos(clientX) {
      var r = ba.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      var pct = p * 100;
      if (after) after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      if (divider) divider.style.left = pct + '%';
      if (handle) handle.style.left = pct + '%';
    }
    function down(e) { dragging = true; setPos((e.touches ? e.touches[0] : e).clientX); }
    function move(e) { if (dragging) setPos((e.touches ? e.touches[0] : e).clientX); }
    function up() { dragging = false; }
    ba.addEventListener('mousedown', down);
    ba.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
  });

  // Meter-fill animation is owned by the PDP section script, which also guarantees
  // the final width. A second observer here used to zero the same bars and fight it.
})();
